<template>
  <div class="">
    <div class=" w-100 bg-white sticky-top"><app-header></app-header></div>
    <div class="app-wrapper">
      <router-view class="ex-wrapper"></router-view>
    </div>
  </div>
</template>
<script>
import AppHeader from "../common/ex-header.vue";
export default {
  components: {
    AppHeader
  }
}
</script>
<style>
.ex-wrapper{
  width: 100%;
  background: #fff;
  min-height: 100vh;
}
</style>